module.exports = __webpack_public_path__ + "img/popup_standard_pay_head.5c39a81f.png";